import React from 'react';
import { Navbar, NavLink } from 'react-bootstrap';
import NavbarCollapse from 'react-bootstrap/esm/NavbarCollapse';
import NavbarToggle from 'react-bootstrap/esm/NavbarToggle';
import Logo from '../Logo/Logo';

const Header: React.FC = () => {
  return (
    <>
      <Navbar collapseOnSelect bg="light" expand="lg" dir="rtl">
        <Navbar.Brand href="/" style={{ margin: '0 0 0 30px' }}>
          <Logo />
        </Navbar.Brand>
        <NavbarToggle id="nav-toggle" />
        <NavbarCollapse id="nav-collapse">
          <NavLink href="/add-account">أضف حسابك مجاناً</NavLink>
        </NavbarCollapse>
      </Navbar>
    </>
  );
};

export default Header;
